module.exports = __webpack_public_path__ + "static/media/back6.60896fe4.png";